export const roomSetupUiPositions = {
    wallInput1: [ 500, 200 ],
    wallInput2: [ 400, 400 ],
    wallInput3: [ 600, 400 ],
    wallInput4: [ 500, 600 ],
    roomType: [ 1400, 200 ],
    roomConfirm: [ 500, 800 ],
};